"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
var Label = styled_components_1["default"].label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: none;\n  user-select: none;\n  display: block;\n  margin: 0;\n  line-height: ", ";\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  font-weight: ", ";\n\n    ", " ", " ", ";\n"], ["\n  pointer-events: none;\n  user-select: none;\n  display: block;\n  margin: 0;\n  line-height: ", ";\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  font-weight: ", ";\n\n    ", " ", " ", ";\n"])), styled_system_1.themeGet('lineHeights.display'), styled_system_1.themeGet('space.xxs'), styled_system_1.themeGet('space.xxs'), styled_system_1.themeGet('fontWeights.bold'), styled_system_1.space, styled_system_1.fontSize, styled_system_1.color);
Label.displayName = 'Label';
// @ts-ignore
Label.isLabel = true;
Label.defaultProps = {
    fontSize: [1, 2],
    color: 'darkGray'
};
exports["default"] = Label;
var templateObject_1;
//# sourceMappingURL=Label.js.map